import { chooseData } from "../../Types/Types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getChooseSimForm } from "../middleware/chooseMiddleware";

interface chooseDataState {
  loading: boolean;
  error: string | null;
  dataChoose: chooseData[] | null;
}

const initialState: chooseDataState = {
  loading: false,
  error: null,
  dataChoose: null,
};

const chooseSlice = createSlice({
  name: "chooseSimForm",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getChooseSimForm.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getChooseSimForm.fulfilled,
        (state, action: PayloadAction<chooseData[]>) => {
          state.loading = false;
          state.dataChoose = action.payload;
        }
      )
      .addCase(
        getChooseSimForm.rejected,
        (state, action: PayloadAction<any>) => {
          state.error = action.payload;
        }
      );
  },
});

export default chooseSlice.reducer;
